import * as React from 'react';

import { ViewLarge, Viewport, ViewSmall } from '@shared-ui/viewport-context';

import { UitkSpacing } from 'uitk-react-spacing';

import { PlaybackFilter } from './playback/playback-filter';

export const ResultHeaderFilterPills: React.FC = () => (
  <Viewport>
    <ViewSmall>
      <UitkSpacing padding={{ blockend: 'three' }}>
        <div>
          <PlaybackFilter />
        </div>
      </UitkSpacing>
    </ViewSmall>
    <ViewLarge>
      <PlaybackFilter wrapPills />
    </ViewLarge>
  </Viewport>
);

ResultHeaderFilterPills.displayName = 'ResultHeaderFilterPills';
